import { CommonModule } from '@angular/common'
import {
    Component,
    input,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { injectCurrentUser, injectIsMobile } from '@mattrika/benefit-core'
import { HeaderAdminDefaultComponent } from '../../headers/header-admin-default/header-admin-default.component'
import { SidebarAdminDefaultComponent } from '../../sidebars/sidebar-admin-default/sidebar-admin-default.component'
import { navigationGroups as defaultNavigationGroups } from '../../sidebars/sidebar-admin-default/sidebar.data'
import { NavigationGroup } from '../../sidebars/sidebar-admin-default/sidebar.model'

@Component({
    selector: 'app-layout-admin-default',
    imports: [
        CommonModule,
        SidebarAdminDefaultComponent,
        HeaderAdminDefaultComponent,
    ],
    templateUrl: './layout-admin-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-admin-default.component.css',
})
export class LayoutAdminDefaultComponent {
    logoSrc = input('assets/images/cjc.svg')
    logoSrcCollapsed = input('')
    logoAlt = input('Full Logo')
    userEmail = input('')
    navigationGroups = input<NavigationGroup[]>(defaultNavigationGroups)

    readonly user = injectCurrentUser()
    private readonly isMobile = injectIsMobile()

    isSidebarCollapsed = signal(false)
    isMobileSidebarOpen = signal(false)

    toggleSidebar() {
        if (this.isMobile()) {
            this.isMobileSidebarOpen.update((v) => !v)
        } else {
            this.isSidebarCollapsed.update((v) => !v)
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen.set(false)
    }
}
